import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import { gender_list } from "../../Shared/List"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect"
import FileField from "../../Shared/FileField"

const EmployeesForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [genderOptions, setGenderOptions] = useState([{id: "", name: '-- Please choose gender --', public: 'None'}])
    const [categoryOptions, setCategoryOptions] = useState([{id: "", name: '-- Please choose occupation --', pub: 'None'}])

    const [formData, setFormData] = useState({
        full_name: "",
        contact_number: 61,
        gender: "",
        category_id: "",
        salary: 0,
        responsible_name: "",
        responsible_contact: "",
        picture: "",
        contract: "",
    })
    const {full_name, contact_number, gender, category_id, salary, responsible_name, responsible_contact, picture, contract} = formData

    const navigate = useNavigate()

    const loadOptions = async (url, query, setOptions) => {
        const genders = genderOptions
        gender_list.map(gender => (
            genders.push({
                id: gender.id,
                name: gender.name,
                public: gender.key
            })
        ))
        setGenderOptions(genders)
        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        const { name, value, files } = e.target;
        // const value = e.target.value === "" ? null : e.target.value;
        setFormData((prev) => {
        const isFile = name === "contract" || name === "picture";
        const newValue = isFile ? files[0] : value;
        return {
            ...prev,
            [name]: newValue,
        };
        });
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const gender_name = gender_list[formData.gender -1]?.name || "Male"
        const payload = {full_name, contact_number, gender: gender_name, category_id, salary, responsible_name, responsible_contact, picture, contract}
        addEmployee(payload)
    }
    
    // add employee
    const addEmployee = async (payload) => {
        setIsLoading(true);

        const dataToSend = new FormData();
        dataToSend.append("picture", payload.picture);
        dataToSend.append("contract", payload.contract);
        dataToSend.append("full_name", payload.full_name);
        dataToSend.append("contact_number", payload.contact_number);
        dataToSend.append("gender", payload.gender);
        dataToSend.append("category_id", payload.category_id);
        dataToSend.append("salary", payload.salary);
        dataToSend.append("responsible_name", payload.responsible_name || "");
        dataToSend.append("responsible_contact", payload.responsible_contact || "");
        
        try {
            const response = await Server.post('/employees/', dataToSend, {headers: {'Content-Type': 'multipart/form-data'}});
            toast.success(response?.data?.detail);
            navigate('/employees');
            setIsLoading(false);

        } catch (error) {
            setIsLoading(false);
            if(error.response.status === 401){
                navigate('/login');
            }else if (error.response.status === 422) {
                setErrors({});
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ));
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header bg-info p-2 justify-content-center">
                <h3 className="card-title">Create New Employee</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Full Name"
                                name="full_name"
                                type="text"
                                label="Name"
                                value={full_name}
                                onChange={onChange}
                                error={errors.full_name}
                            />
                        </div>

                        <div className="col-md-3">
                            <InputField
                                placeholder="Employee Contact"
                                name="contact_number"
                                type="number"
                                label="Contact"
                                value={contact_number}
                                onChange={onChange}
                                error={errors.contact_number}
                            />
                        </div>

                        <div className="col-md-3">
                            <SelectField
                                name="gender"
                                label="Gender"
                                value={parseInt(gender)}
                                options={genderOptions}
                                onChange={onChange}
                                error={errors.gender}
                            />
                        </div>

                        <div className="col-md-3">
                        <InputField
                            placeholder="Salary"
                            name="salary"
                            type="number"
                            label="Salary"
                            value={salary}
                            onChange={onChange}
                            error={errors.salary}
                        />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="category_id"
                                label="Occupation"
                                value={category_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('employee-categories', query, setCategoryOptions)}
                                options={categoryOptions}
                                placeholder="Start typing to search..."
                                error={errors.category_id}
                            />
                        </div>

                        <div className="col-md-4">
                        <InputField
                            placeholder="Responsible Person Name (Optional)"
                            name="responsible_name"
                            type="text"
                            label="Responsible Name"
                            value={responsible_name}
                            onChange={onChange}
                            error={errors.responsible_name}
                        />
                        </div>

                        <div className="col-md-4">
                            <InputField
                                placeholder="Responsible Person Contact (Optional)"
                                name="responsible_contact"
                                type="number"
                                label="Responsible Contact"
                                value={responsible_contact}
                                onChange={onChange}
                                error={errors.responsible_contact}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FileField
                                name="contract"
                                type="file"
                                label="Contract(Optional)"
                                value={contract}
                                onChange={onChange}
                                error={errors.contract}
                            />
                        </div>
                        <div className="col-md-6">
                            <FileField
                                name="picture"
                                type="file"
                                label="Picture(Optional)"
                                value={picture}
                                onChange={onChange}
                                error={errors.picture}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Employee" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default EmployeesForm
